import {
  PlanType,
  PaymentCycle,
  SwitchPlanType,
  CurrentPlanInOfferingMode,
} from '../../enums';
import { Omit } from '../../types/global-types';

export enum BiEventIDs {
  ORDER_PAGE_VALIDATION_ERROR = 105,
  ORDER_PAGE_FATAL_ERROR = 177,
  ORDER_PAGE_SUBMIT_PRESSED = 178,
  ORDER_PAGE_BUSINESS_ERROR = 176,
  CHECKOUT_PAGE_VIEW_TOOLTIP = 3916,
  PACKAGE_PICKER_LOADED = 940,
  A_PLAN_SELECTED = 3905,
  A_CYCLE_SELECTED = 3906,
  A_PAYMENT_PAGE_READY = 942,
  HOVER_ON_FEATURES = 3910,
  CHANGE_PP_TYPE = 3912,
  TABS_TOOLTIP_CLOSED = 3913,
  PREVIOUS_STEP_SELECT = 3907,
  R_PREMIUM_ORDER_PAGE_SUMBIT_SUCCESS = 3103,
  R_PREMIUM_ORDER_PAGE_SUBMIT_PENDING = 3104,
  R_PREMIUM_ORDER_PAGE_SUBMIT_PENDING_BOLETO = 3202,
  A_VIEW_DOUBLE_PURCHASE_POPUP = 1220,
  A_DOUBLE_PURCHASE_POPUP_VIEW_BUTTON_CLICKED = 1221,
  REQUEST_CALL_POPUP_LOAD = 3914,
  REQUEST_CALL_POPUP_CTA = 3915,
  VIEW_PRODUCT_FEATURE_TOOLTIP = 3910,
  CHANGE_PLAN_POPUP_OPENED = 7900,
  CHANGE_PLAN_POPUP_CLICK_CHANGE = 7901,
  CHANGE_PLAN_POPUP_CLOSED = 7902,
  VIEW_CURRENT_PLAN_MODAL_OPENED = 7503,
  VIEW_CYCLE_DISCOUNT_TOOLTIP = 3916,
  CLICK_ON_FAQ_ITEM = 3917,
  CLICK_ON_SHOW_FEATURES = 3918,
  CLICK_ON_SHOW_ALL_FEATURES = 3919,
  STICKY_HEADER_MOBILE_GRID = 3903,
  SELECT_PLAN_RADIO_BUTTONS_MOBILE_GRID = 3904,
}

export const EventActionMap = {
  [BiEventIDs.PACKAGE_PICKER_LOADED]: 'A_PremiumPPLoaded',
  [BiEventIDs.A_PLAN_SELECTED]: 'A_PackagePickerEventAddInfoAction',
  [BiEventIDs.A_CYCLE_SELECTED]: 'OnePage PP > Select cycle',
  [BiEventIDs.A_PAYMENT_PAGE_READY]: 'A_PaymentPageReady',
  [BiEventIDs.CHANGE_PP_TYPE]: 'NewDeal > Click change pp type',
  [BiEventIDs.PREVIOUS_STEP_SELECT]: 'OnePage PP > Change',
  [BiEventIDs.ORDER_PAGE_FATAL_ERROR]:
    'R_SbsOrderPagePremiumPurchaseFatalError',
  [BiEventIDs.ORDER_PAGE_SUBMIT_PRESSED]:
    'A_SbsPremiumPurchaseBuyButtonPressed',
  [BiEventIDs.R_PREMIUM_ORDER_PAGE_SUMBIT_SUCCESS]:
    'R_PremiumOrderPageSubmitSuccess',
  [BiEventIDs.ORDER_PAGE_VALIDATION_ERROR]: 'R_PremiumPurchaseError',
  [BiEventIDs.ORDER_PAGE_BUSINESS_ERROR]:
    'R_SbsOrderPagePremiumPurchaseBusinessError',
  [BiEventIDs.VIEW_CYCLE_DISCOUNT_TOOLTIP]: 'Discount tooltip shown',
  [BiEventIDs.CLICK_ON_FAQ_ITEM]: 'package picker > click on question',
  [BiEventIDs.CLICK_ON_SHOW_FEATURES]: 'package picker > Show Feature',
  [BiEventIDs.CLICK_ON_SHOW_ALL_FEATURES]: 'package picker > Show All features',
  [BiEventIDs.CHECKOUT_PAGE_VIEW_TOOLTIP]: 'Checkout Page > view tooltip',
};

export enum ContinueEventSteps {
  product = 'product',
  cycle = 'cycle',
  purchasePage = 'purchasePage',
}

export enum PlanTypeClick {
  Top = 'top_clicked',
  Bottom = 'bottom_clicked',
}

export enum FlowType {
  ChangePlan = 'change_plan',
  Upgrade = 'upgrade',
  Regular = 'regular',
}

export const BiStepNames: ContinueEventSteps[] = [
  ContinueEventSteps.product,
  ContinueEventSteps.cycle,
  ContinueEventSteps.purchasePage,
];

export const PaymentCycle_BIMap = {
  [PaymentCycle.MONTHLY]: 3,
  [PaymentCycle.YEARLY]: 6,
  [PaymentCycle.YEAR2]: 7,
  [PaymentCycle.YEAR3]: 8,
  [PaymentCycle.QUARTERLY]: 4,
};

// todo arielw, fix so this can work on storybook
// export const PaymentCycle_BIMap = {
//   [PaymentCycle.MONTHLY]: PaymentCycle_BI.MONTHLY,
//   [PaymentCycle.YEARLY]: PaymentCycle_BI.YEARLY,
//   [PaymentCycle.YEAR2]: PaymentCycle_BI.YEAR2,
//   [PaymentCycle.YEAR3]: PaymentCycle_BI.YEAR3
// };

export interface BiEvent {
  evid: BiEventIDs;
  action: string;
}

export interface BiEventDefaultParams {
  eventAggregator: string;
  siteGuid: string;
  referralAdditionalInfo?: string;
  referer?: string;
  newPurchase?: string;
}

export interface ChangeStepBiEvent extends BiEvent {
  fromStep: string;
  cycle: any;
  productId: number;
  productGuid: string | undefined;
}

export interface PlanTypeInfoBiEvent extends BiEvent {
  ppType: PlanType;
  pricing: BiPlan[];
  clickType: PlanTypeClick;
  currency: string;
}

export interface BiPlan {
  id: number;
  title: string;
  subtitle: string;
  price: number;
  discount: number;
}

export interface AppLoadBiEvent extends BiEvent {
  abTesting: String;
  ppType: PlanType;
  cycle: any;
  productId: number;
  productGuid: string | undefined;
  pricing: BiPlan[];
  currency: string;
  changePlanType: CurrentPlanInOfferingMode;
  currentProductId: number | null;
  intent: string;
  intentDomainName: string | null;
}

export interface SelectPlanBiEvent extends BiEvent {
  ppType: PlanType;
  cycle: any;
  productId: number;
  productGuid: string | undefined;
  referralAdditionalInfo: string;
}

export interface SelectCycleBiEvent extends BiEvent {
  eventAggregator?: string;
  cycleId?: PaymentCycle;
  cycle: any;
  additionalInfo?: string;
  productId: number;
  productGuid: string | undefined;
}
export interface CheckoutPageLoadedBiEvent extends SelectCycleBiEvent {
  pricing: {
    fullPrice: number;
    priceAfterDiscount: number;
  };
  currency: string;
}

export interface CheckoutPageBiEvent extends BiEvent {
  cycle: number;
  paymentMethod?: number;
  eventAggregator?: string;
  additionalInfo?: string;
  productId: number;
  productGuid: string | undefined;
}

export interface DoublePurchaseBiEvent extends BiEvent {
  productTypeId: string;
  conflictingServiceGuid: string;
  reason: string;
  productGuid: string | undefined;
}

export interface RequestCallCTABiEvent extends BiEvent {
  clickType: 'close' | 'submit';
}

export interface RequestCallPopupLoadBiEvent extends BiEvent {
  ppType: PlanType;
}

export interface ViewCurrentPlanBiEvent extends BiEvent {
  changePlanType: CurrentPlanInOfferingMode;
  currentProductId: number;
  currentCycleId: number;
  packageId: string;
  flowType: FlowType;
}

export interface ChangePlanBiEvent extends BiEvent {
  changeType: SwitchPlanType;
  productId: number;
  cycle: number;
  newCycle: number;
  newProductId: number;
  packageId: string;
}

export interface ViewProductFeatureTooltipBiEvent extends BiEvent {
  cycle: any;
  productId: number;
  featureKey: string;
  fromStep: 'select_plan' | 'select_cycle' | 'select_purchase_page';
}

export interface ViewCycleDiscountTooltip extends BiEvent {
  ppType: PlanType;
  referralAdditionalInfo?: string;
  siteGuid: string;
  eventAggregator?: string;
}

export interface ClickOnFAQItem extends BiEvent {
  questionType: string;
  clickType: string;
  ppType: string;
  siteGuid: string;
}

export interface ClickOnShowFeatures extends BiEvent {
  showFeatureType: string;
  clickType: string;
  ppType: string;
  siteGuid: string;
}

export interface ClickOnShowAllFeatures extends BiEvent {
  clickType: string;
  ppType: string;
  siteGuid: string;
}

export interface CheckoutPageViewTooltip extends BiEvent {
  siteGuid: string;
  tooltipName: string;
}

export interface SelectPlanRadioButtonsMobileGrid extends BiEvent {
  ppType: PlanType;
  productId: number;
  siteGuid: string;
  newPurchase: string;
}

export interface StickyHeaderMobileGrid extends BiEvent {
  ppType: PlanType;
  siteGuid: string;
  newPurchase: string;
}

export type BiEventParams<T> = Omit<T, keyof BiEvent>;

export interface BiLogger {
  logPlansPageLoadedBiEvent(
    additionalParams: BiEventParams<AppLoadBiEvent>,
  ): void;
  logSubmitPurchaseClickedBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logPurchaseSuccessBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logPurchasePendingBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logSelectCycleBiEvent(
    additionalParams: BiEventParams<SelectCycleBiEvent>,
  ): void;
  logPaymentPageReadyBiEvent(
    additionalParams: BiEventParams<CheckoutPageLoadedBiEvent>,
  ): void;
  logChangeTabBiEvent(
    additionalParams: BiEventParams<PlanTypeInfoBiEvent>,
  ): void;
  logSelectPlanBiEvent(
    additionalParams: BiEventParams<SelectPlanBiEvent>,
  ): void;
  logStepBackBiEvent(additionalParams: BiEventParams<ChangeStepBiEvent>): void;
  logOrderPageValidationErrorBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logOrderPageFatalErrorBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logOrderPageBusinessErrorBiEvent(
    additionalParams: BiEventParams<CheckoutPageBiEvent>,
  ): void;
  logDoublePurchasePopupViewed(
    additionalParams: BiEventParams<DoublePurchaseBiEvent>,
  ): void;
  logDoublePurchasePopupCTA(): void;
  logTabsTooltipClosed(): void;
  logRequestCallPopupLoad(
    additionalParams: BiEventParams<RequestCallPopupLoadBiEvent>,
  ): void;
  logRequestCallPopupCTA(
    additionalParams: BiEventParams<RequestCallCTABiEvent>,
  ): void;
  logViewProductFeatureTooltip(
    additionalParams: BiEventParams<ViewProductFeatureTooltipBiEvent>,
  ): void;
  logCurrentPlanModalOpened(
    additionalParams: BiEventParams<ViewCurrentPlanBiEvent>,
  ): void;
  logChangePlanPopupOpened(
    additionalParams: BiEventParams<ChangePlanBiEvent>,
  ): void;
  logChangePlanPopupClickChange(
    additionalParams: BiEventParams<ChangePlanBiEvent>,
  ): void;
  logChangePlanPopupClosed(
    additionalParams: BiEventParams<ChangePlanBiEvent>,
  ): void;
  logDiscountTooltipIsShown(
    additionalParams: BiEventParams<ViewCycleDiscountTooltip>,
  ): void;
  logClickOnFAQItem(additionalParams: BiEventParams<ClickOnFAQItem>): void;
  logClickOnShowFeatures(
    additionalParams: BiEventParams<ClickOnShowFeatures>,
  ): void;
  logClickOnShowAllFeatures(
    additionalParams: BiEventParams<ClickOnShowAllFeatures>,
  ): void;
  logCheckoutPageViewTooltipBiEvent(
    additionalParams: BiEventParams<CheckoutPageViewTooltip>,
  ): void;
  logSelectPlanRadioButtonsMobileGrid(
    additionalParams: BiEventParams<SelectPlanRadioButtonsMobileGrid>,
  ): void;
  logStickyHeaderMobileGrid(
    additionalParams: BiEventParams<StickyHeaderMobileGrid>,
  ): void;
}
